import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './AboutSection.module.scss'

const AboutSection: React.FC = () => {
    const { t } = useTranslation()

    return (
        <PageSection
            title={t('about.title')}
            style={{ backgroundColor: 'var(--bg-muted)' }}
        >
            <div className={cls.wrap}>
                <p className={cls.lead}>{t('about.text')}</p>
                <div className={cls.statRow}>
                    <div className={cls.stat}>
                        <span className={cls.statNum}>$90</span>
                        <span className={cls.statLabel}>{t('about.perDay')}</span>
                    </div>
                    <div className={cls.stat}>
                        <span className={cls.statNum}>3+</span>
                        <span className={cls.statLabel}>{t('about.minDays')}</span>
                    </div>
                    <div className={cls.stat}>
                        <span className={cls.statNum}>∞</span>
                        <span className={cls.statLabel}>{t('about.mileage')}</span>
                    </div>
                </div>
            </div>
        </PageSection>
    )
}

export default AboutSection
